import {useEffect, useMemo, useState} from "react";
import {API_URL, IMAGE_URL, SOCKET} from "../../URL";
import {BoardPhotos} from "./components/BoardPhotos";
import {BoardGradient} from "./components/BoardGradient";
import {
    SET_IS_EDIT,
    SET_SELECT_IMAGE,
    SET_SHOW_FORM,
    SET_TITLE
} from "../../store/reducers/BoardCreate/constants";
import {useDispatch, useSelector} from "react-redux";
import {handleCreateBoard} from "../../hooks/handleCreateBoard";
import {BoardStyleAPI} from "../../store/api/get/BoardStyle/BoardStyleAPI";
import {CREATE_BOARD, EDIT_BOARD} from "../../store/constants";

const colorOptions = [
    "#dfe8f6",
    "linear-gradient(135deg, #1e6fff, #34b3c1)",
    "linear-gradient(135deg, #0b63d8, #1446a0)",
    "linear-gradient(135deg, #243b87, #c04c97)",
    "linear-gradient(135deg, #7b61d1, #d96bb3)",
    "linear-gradient(135deg, #e74c3c, #f4a340)",
];

export const BoardsCreate = ({is_header}) => {
    const dispatch = useDispatch();
    const showForm = useSelector((state) => state.boardCreate.showForm);
    const title = useSelector((state) => state.boardCreate.title);
    const selectedImage = useSelector((state) => state.boardCreate.selectedImage);
    console.log(selectedImage);
    const isEdit = useSelector((state) => state.boardCreate.isEdit);
    const user = useSelector((state) => state.user.user);
    const boards = useSelector((state) => state.boards.boards);
    const activeBoard = useSelector((state) => state.boards.activeBoard);
    const boardStyles = useSelector((state) => state.boardStyle.boardStyle);
    const [showBackgroundPicker, setShowBackgroundPicker] = useState(false);
    const [showColorsPicker, setShowColorsPicker] = useState(false);
    const [selectedColor, setSelectedColor] = useState("");
    const previewStyles = useMemo(() => boardStyles?.board_styles?.slice(0, 4) || [], [boardStyles]);
    const moreStyles = useMemo(() => boardStyles?.board_styles?.slice(0, 6) || [], [boardStyles]);
    console.log(boardStyles);
    useEffect(() => {
        dispatch(BoardStyleAPI(user.id));
    }, [dispatch]);
    useEffect(() => {
        if (!showForm) return;

        if (isEdit && activeBoard) {
            dispatch({
                type: SET_TITLE,
                payload: activeBoard.name || ""
            });

            const hasImageBackground = !!activeBoard.path;
            const hasColorBackground = !!activeBoard.color;

            if (hasImageBackground) {
                dispatch({
                    type: SET_SELECT_IMAGE,
                    payload: {
                        id: activeBoard.id || null,
                        path: activeBoard.path,
                        name: activeBoard.background_name || activeBoard.name || "",
                        object_id: activeBoard.object_id || null,
                    },
                });

                setSelectedColor("");
            } else if (hasColorBackground) {
                dispatch({type: SET_SELECT_IMAGE, payload: null});
                setSelectedColor(activeBoard.color);
            } else {
                dispatch({type: SET_SELECT_IMAGE, payload: null});
                setSelectedColor("");
            }
        } else {
            dispatch({type: SET_TITLE, payload: ""});
            dispatch({type: SET_SELECT_IMAGE, payload: null});
            setSelectedColor("");
        }
    }, [showForm, isEdit, activeBoard, dispatch]);

    const handleOpen = () => {
        dispatch({type: SET_IS_EDIT, payload: false});
        dispatch({type: SET_TITLE, payload: ""});
        dispatch({type: SET_SELECT_IMAGE, payload: null});
        dispatch({type: SET_SHOW_FORM, payload: true});

        setSelectedColor("");
        setShowBackgroundPicker(false);
        setShowColorsPicker(false);
    };

    const handleClose = () => {
        dispatch({type: SET_SHOW_FORM, payload: false});
        dispatch({type: SET_TITLE, payload: ""});
        dispatch({type: SET_SELECT_IMAGE, payload: null});
        dispatch({type: SET_IS_EDIT, payload: false});

        setSelectedColor("");
        setShowBackgroundPicker(false);
        setShowColorsPicker(false);
    };

    const handleSelectImage = (el) => {
        dispatch({type: SET_SELECT_IMAGE, payload: el});
        console.log(selectedImage);
        setSelectedColor("");
    };

    const handleSelectColor = (color) => {
        setSelectedColor(color);
        dispatch({type: SET_SELECT_IMAGE, payload: null});
    };
    useEffect(() => {
        SOCKET.on("create_board", (data) => {
            dispatch({
                type: CREATE_BOARD,
                payload: data
            });
        });

        return () => {
            SOCKET.off("create_board");
        };
    }, [dispatch]);
    useEffect(() => {
        SOCKET.on("change_board", (data) => {
            dispatch({type: EDIT_BOARD, payload: data.data})
        });

        return () => {
            SOCKET.off("change_board");
        }
    }, [dispatch]);
    const handleUpload = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onloadend = async () => {
            const base64 = reader.result;

            const response = await fetch(API_URL + "/post/upload_background_image/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({
                    user_id: user?.id,
                    image: base64
                })
            });

            const data = await response.json();

            dispatch({
                type: SET_SELECT_IMAGE,
                payload: {
                    ...data,
                    is_uploaded: true
                }
            });
        };

        reader.readAsDataURL(file);
    };
    return (
        <>
            {!is_header && (
                <button
                    className="board__create"
                    type="button"
                    onClick={handleOpen}
                >
                    Create new board
                </button>
            )}

            {showForm && (
                <div className="boardModalWrapper">
                    <form
                        className="boardModal"
                        onSubmit={(e) =>
                            handleCreateBoard(
                                e,
                                selectedColor,
                                title,
                                user,
                                selectedImage,
                                boards,
                                dispatch,
                                isEdit,
                                activeBoard
                            )
                        }
                    >
                        <div className="boardModal__header">
                            <h2>{isEdit ? "Edit Board" : "Create board"}</h2>
                            <button
                                type="button"
                                className="boardModal__close"
                                onClick={handleClose}
                            >
                                ×
                            </button>
                        </div>

                        <div className="boardModal__preview">
                            {selectedImage ? (
                                selectedImage.path?.startsWith("uploads") ||
                                selectedImage.path?.startsWith("data:image") ? (
                                    <img
                                        src={
                                            selectedImage.path.startsWith("data:image")
                                                ? selectedImage.path
                                                : IMAGE_URL + "/media/" + selectedImage.path
                                        }
                                        alt={selectedImage.name || "preview"}
                                        className="boardModal__previewImage"
                                    />
                                ) : (
                                    <div
                                        className="boardModal__previewColor"
                                        style={{background: selectedImage.path}}
                                    />
                                )
                            ) : selectedColor?.color ? (
                                <div
                                    className="boardModal__previewColor"
                                    style={{background: selectedColor.color}}
                                />
                            ) : (
                                <div className="boardModal__previewEmpty">
                                    Preview
                                </div>
                            )}
                        </div>

                        <div className="boardModal__section">
                            <label className="boardModal__label">Background</label>

                            <div className="boardModal__styles">
                                {previewStyles.map((el) => {
                                    const imageURL = IMAGE_URL + "/media/" + el.path;
                                    const isActive =
                                        selectedImage?.path === el.path ||
                                        selectedImage?.id === el.id;

                                    return (
                                        <button
                                            type="button"
                                            key={el.id}
                                            className={`boardModal__styleItem ${isActive ? "active" : ""}`}
                                            onClick={() => handleSelectImage(el)}
                                            title={el.name || ""}
                                        >
                                            <img
                                                src={imageURL}
                                                alt={el.name || "style"}
                                                className="boardModal__styleImg"
                                            />
                                            {isActive && (
                                                <span className="boardModal__check">✓</span>
                                            )}
                                        </button>
                                    );
                                })}

                                <button
                                    type="button"
                                    className="boardModal__styleMore"
                                    onClick={() => {
                                        setShowBackgroundPicker((prev) => !prev);
                                        setShowColorsPicker(false);
                                    }}
                                >
                                    ...
                                </button>
                            </div>

                            <div className="boardModal__colorsPreview">
                                {boardStyles?.background_colors?.slice(0, 5).map((el) => {
                                    const isActive = selectedColor?.id === el.id;

                                    return (
                                        <button
                                            key={el.id}
                                            type="button"
                                            className={`boardModal__colorItem ${
                                                isActive ? "active" : ""
                                            }`}
                                            style={{ background: el.color }}
                                            onClick={() => handleSelectColor(el)}
                                        >
                                            {isActive && (
                                                <span className="boardModal__check">✓</span>
                                            )}
                                        </button>
                                    );
                                })}

                                <button
                                    type="button"
                                    className="boardModal__styleMore"
                                    onClick={() => {
                                        setShowColorsPicker((prev) => !prev);
                                        setShowBackgroundPicker(false);
                                    }}
                                >
                                    ...
                                </button>
                            </div>
                            {
                                boardStyles?.background_images?.map((el) => {
                                    const isActive =
                                        selectedImage?.object_id === el.object_id;

                                    return (
                                        <div className="boardModal__styles">
                                            <button
                                                key={el.id}
                                                type="button"
                                                className={`boardModal__styleItem ${isActive ? "active" : ""}`}
                                                onClick={() => handleSelectImage(el)}
                                            >
                                                <img
                                                    src={IMAGE_URL + "/media/" + el.path} // կամ el.path կախված serializer-ից
                                                    className="boardModal__styleImg"
                                                />

                                                {isActive && <span className="boardModal__check">✓</span>}
                                            </button>
                                        </div>
                                    );
                                })
                            }
                            <div className="boardModal__upload">
                                <input
                                    type="file"
                                    accept="image/*"
                                    id="boardUpload"
                                    hidden
                                    onChange={handleUpload}
                                />

                                <label htmlFor="boardUpload" className="boardModal__uploadLabel">
                                    +
                                </label>
                            </div>
                        </div>

                        <div className="boardModal__section">
                            <label className="boardModal__label">
                                Board title <span>*</span>
                            </label>

                            <input
                                type="text"
                                className={`boardModal__input ${!title.trim() ? "error" : ""}`}
                                value={title}
                                onChange={(e) =>
                                    dispatch({
                                        type: SET_TITLE,
                                        payload: e.target.value
                                    })
                                }
                                autoFocus
                            />

                            {!title.trim() && (
                                <p className="boardModal__error">
                                    👋 Board title is required
                                </p>
                            )}
                        </div>

                        <div className="boardModal__actions">
                            <button
                                type="submit"
                                className="boardModal__createBtn"
                                disabled={!title.trim()}
                            >
                                {isEdit ? "Edit" : "Create"}
                            </button>
                        </div>

                        <p className="boardModal__footer">
                            By using images from Unsplash, you agree to their license and Terms of Service
                        </p>
                    </form>

                    {showBackgroundPicker && (
                        <BoardPhotos
                            setShowBackgroundPicker={setShowBackgroundPicker}
                            moreStyles={moreStyles}
                            handleSelectImage={handleSelectImage}
                            selectedImage={selectedImage}
                        />
                    )}

                    {showColorsPicker && (
                        <BoardGradient
                            colorOptions={boardStyles?.background_colors}
                            selectedColor={selectedColor}
                            handleSelectColor={handleSelectColor}
                        />
                    )}
                </div>
            )}
        </>
    );
};